import React, { useState } from 'react';
import { Nav, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CoreTracking } from '../../../../models/CoreTracking';
import MapOneRosterTrackingActivity from './MapOneRosterTrackingActivity';
import MapOneRosterTrackingGroup from './MapOneRosterTrackingGroup';
import { useTranslation } from 'react-i18next';
import { FlowSyncObjectType } from '../../../../models/CoreModels';

enum OneRosterTrackingOperation {
    None = 0,
    Map = 4,
}

interface OneRosterTrackingOperationsMenuProps {
    tracking: CoreTracking
    onClose?: (success: boolean) => void
    disabled?: boolean
    flowSyncObjectType?: FlowSyncObjectType
}

const OneRosterTrackingOperationsMenu: React.FC<OneRosterTrackingOperationsMenuProps> = (props) => {
    const [action, setAction] = useState(OneRosterTrackingOperation.None);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { t } = useTranslation(['schoolAdministration']);

    if (!isOneRosterTracking(props.tracking)) {
        return null;
    }

    const close = (success: boolean) => {
        setAction(OneRosterTrackingOperation.None);

        if (props.onClose) {
            props.onClose(success);
        }
    }

    return <>
        <Nav className="right">
            <Dropdown nav isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                <DropdownToggle nav style={{ display: 'inline' }}>
                    <FontAwesomeIcon icon="ellipsis" className="icon" title={t('trackingOperations.mapOneRosterTracking.action.title', {ns: 'schoolAdministration'})} />
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => setAction(OneRosterTrackingOperation.Map)} disabled={props.disabled}>{t('trackingOperations.mapOneRosterTracking.action.switch', {ns: 'schoolAdministration'})}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </Nav>
        {(action === OneRosterTrackingOperation.Map && props.flowSyncObjectType === FlowSyncObjectType.Activity) && <MapOneRosterTrackingActivity tracking={props.tracking} close={close} />}
        {(action === OneRosterTrackingOperation.Map && props.flowSyncObjectType === FlowSyncObjectType.Group) && <MapOneRosterTrackingGroup tracking={props.tracking} close={close} />}
    </>;
}

export const isOneRosterTracking = (tracking: CoreTracking): boolean => {
    if (tracking.sourceName !== 'OneRoster') {
        return false;
    }

    if (!tracking.active) {
        return false;
    }

    switch (tracking.sourceObjectType) {
        case 'Class': return true;
        default: return false;
    }
}

export default OneRosterTrackingOperationsMenu;
